module.exports = __webpack_public_path__ + "static/media/WiCanvas5dualstand.867fd9e0.jpg";